import { get, post } from '../client/client';
import { endpoint } from '../endpoint';
import type {
  PaymentCreate,
  PaymentManagementResponse,
  PaymentPagination,
  PaymentPublic,
} from '../type/payment';

export const createPayment = async (payload: PaymentCreate) => {
  return await post<PaymentPublic, PaymentCreate>(endpoint.createPayment, payload);
};

export const getUserPayments = async (userId: number) => {
  return await get<PaymentPagination>(endpoint.getUserPayments(userId));
};

export const getPaymentsManagement = async () => {
  return await get<PaymentManagementResponse>(endpoint.getPaymentsManagement);
};
